(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const card = document.currentScript && document.currentScript.closest('product-card');
    if (!card) return;

    const control = card.querySelector('[data-vk-card-control]');
    if (!control) return;

    // Prevent double-binding (Shopify section re-render)
    if (control.dataset.vkBound === '1') return;
    control.dataset.vkBound = '1';

    const variantIdInput = control.querySelector('[data-vk-variant-id]');
    const qtyInput = control.querySelector('[data-vk-qty-input]');
    const atcBtn = control.querySelector('[data-vk-atc]');
    const stepper = control.querySelector('[data-vk-stepper]');
    const minus = control.querySelector('[data-vk-minus]');
    const plus = control.querySelector('[data-vk-plus]');
    const countEl = control.querySelector('[data-vk-count]');

    if (!variantIdInput || !qtyInput || !atcBtn || !stepper || !minus || !plus || !countEl) return;

    // Stop clicks from bubbling into product-card/link behaviours
    [control, atcBtn, stepper, minus, plus].forEach(el => {
      el.addEventListener('click', (e) => e.stopPropagation());
      el.addEventListener('pointerdown', (e) => e.stopPropagation());
    });

    const toInt = (v) => {
      const n = parseInt(v, 10);
      return Number.isFinite(n) ? n : 0;
    };

    const getStep = () => Math.max(1, toInt(qtyInput.getAttribute('step')) || 1);
    const getMin = () => Math.max(1, toInt(qtyInput.getAttribute('min')) || 1);
    const getMax = () => {
      const m = qtyInput.getAttribute('max');
      return m ? toInt(m) : null;
    };

    const getVariantId = () => toInt(variantIdInput.value);

    const setQtyUI = (q) => {
      qtyInput.value = String(q);
      countEl.textContent = String(q);
    };

    const showStepper = () => {
      atcBtn.hidden = true;
      stepper.hidden = false;
    };

    const showATC = () => {
      stepper.hidden = true;
      atcBtn.hidden = false;
    };

    const clamp = (q) => {
      const min = getMin();
      const max = getMax();
      let v = q;
      if (v < 0) v = 0;
      if (v > 0 && v < min) v = min;
      if (max != null && v > max) v = max;
      return v;
    };

    const fetchJSON = async (url, payload) => {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      // Shopify returns JSON even on some errors; still try to parse
      return res.json();
    };

    const getCart = async () => {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return res.json();
    };

    const syncFromCart = async () => {
      const variantId = getVariantId();
      if (!variantId) {
        setQtyUI(getMin());
        showATC();
        return;
      }

      const cart = await getCart();
      const item = cart.items.find(i => toInt(i.variant_id) === variantId);
      const qty = item ? toInt(item.quantity) : 0;

      if (qty > 0) {
        setQtyUI(qty);
        showStepper();
      } else {
        setQtyUI(getMin());
        showATC();
      }
    };

    const addDelta = async (delta) => {
      const variantId = getVariantId();
      if (!variantId) return;

      await fetchJSON('/cart/add.js', { id: variantId, quantity: delta });
      await syncFromCart();
      document.dispatchEvent(new Event('cart:refresh'));
    };

    const setAbsoluteQty = async (nextQty) => {
      const variantId = getVariantId();
      if (!variantId) return;

      const cart = await getCart();
      const item = cart.items.find(i => toInt(i.variant_id) === variantId);

      if (!item) {
        if (nextQty <= 0) {
          setQtyUI(getMin());
          showATC();
          return;
        }
        await fetchJSON('/cart/add.js', { id: variantId, quantity: nextQty });
      } else {
        await fetchJSON('/cart/change.js', { id: item.key, quantity: Math.max(0, nextQty) });
      }

      await syncFromCart();
      document.dispatchEvent(new Event('cart:refresh'));
    };

    // Init
    showATC();
    setQtyUI(getMin());
    setTimeout(() => { syncFromCart(); }, 250);

    // Add button => add min qty, then show stepper
    atcBtn.addEventListener('click', async () => {
      const min = getMin();
      showStepper();
      setQtyUI(min);
      await addDelta(min);
    });

    plus.addEventListener('click', async () => {
      const step = getStep();
      await addDelta(step);
    });

    minus.addEventListener('click', async () => {
      const step = getStep();
      const cart = await getCart();
      const variantId = getVariantId();
      const item = cart.items.find(i => toInt(i.variant_id) === variantId);
      const current = item ? toInt(item.quantity) : 0;
      const next = clamp(current - step);
      await setAbsoluteQty(next);
    });

    // If cart refreshes elsewhere, resync the card
    document.addEventListener('cart:refresh', () => {
      setTimeout(() => { syncFromCart(); }, 150);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
